export default __webpack_public_path__ + "static/media/generic-cb-score-gr-4-template.2d110f37.png";